var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_c('v-card',{staticClass:"person"},[_c('div',[_c('app-row',{attrs:{"icon":"user","title":"نام:","value":_vm.person.FName3}}),_c('app-row',{attrs:{"icon":"building","title":"سمت:","value":_vm.person.N_Chart}}),_c('app-row',{attrs:{"icon":"phone","title":"تلفن:","value":_vm.person.Telphone}})],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }